// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-date-range[data-v-643eaf36] {\n  width: 204px;\n  height: 32px;\n  position: relative;\n}\n.search-date-range[data-v-643eaf36] .el-range__icon {\n  position: absolute;\n  margin: 0;\n  float: none;\n  top: 0;\n  right: 1px;\n  line-height: 30px;\n}\n.search-date-range[data-v-643eaf36] .el-range__close-icon {\n  margin-right: 10px;\n}\n.search-date-range[data-v-643eaf36] .el-range-separator {\n  padding: 0;\n  line-height: 20px;\n}", ""]);
// Exports
module.exports = exports;
